import Storage from './Storage';

export default class Accessibility {
    constructor () {

        // Return if not sure if accessibility is set.
        if ('undefined' === typeof gkt_ajax_object || !gkt_ajax_object.accessibility) {
            return;
        }

        this.storage = new Storage();

        this.fontSizeTogglers = document.getElementsByClassName('js-increase-fontsize');
        if( this.fontSizeTogglers ) {
            this.fontSizes();
        }

        this.setCssVariables();
    }

    /**
     * FontSize loop, onclick save.
     */
    fontSizes () {
        if( !! this.fontSizeTogglers ) {
            [ ...this.fontSizeTogglers ].forEach( el => {
                el.addEventListener( 'click', () => {
                    this.storage.set( `accessibility_fontsize_${ gkt_ajax_object.accessibility.fontsize_type }`, el.dataset.value );
                    this.setCssVariables();
                    this.setActive();
                } );
            } );
        }
    }

    /**
     * Set active class to togglers.
     */
    setActive () {
        if( !! this.fontSizeTogglers ) {
            [ ...this.fontSizeTogglers ].forEach( el => {
                if ( el.dataset.value === this.storage.get( `accessibility_fontsize_${ gkt_ajax_object.accessibility.fontsize_type }` ) ) {
                    el.classList.add( 'active' );
                } else if ( el.classList.contains( 'active' ) ) {
                    el.classList.remove( 'active' );
                }
            } );
        }
    }

    /**
     * Set CSS variable based on storage.
     */
    setCssVariables () {
        let fontsize = this.storage.get(`accessibility_fontsize_${gkt_ajax_object.accessibility.fontsize_type}`);
        if (fontsize) {

            if ('pixels' === gkt_ajax_object.accessibility.fontsize_type) {
                fontsize += 'px';
            }

            document.documentElement.style.setProperty('--accessibility-font-amount', `${fontsize}`);

            this.setActive();
        }
    }
}
